<template>
    <div class="auth-container" style="margin-bottom: 50px;">
        <div class="auth-box" style="margin-top: 50px !important;">
            <div v-if="!tokenChecked" class="has-text-centered">
                <img src="/loader-dark.svg">
            </div>

            <div v-if="tokenChecked && !tokenValid">
                <div class="columns">
                    <div class="column has-text-centered">
                        <a href="/">
                            <img :src="require('@/assets/img/logo-icon-new.svg')" alt="Weap.io logo" style="height:40px;">
                        </a>
                        <p class="title">Create account</p>
                        <p style="font-size: 12px; color:#adb5bd">14 days of free trial. No card required. Cancel at anytime.</p>
                    </div>
                </div>

                <div v-show="error" class="notification is-danger" style="font-size: 13px;">{{ error }}</div>

                <!-- BEGIN First Name -->
                <input id="first_name" type="text" v-model="firstName" @keyup.enter="register" :class="{ 'is-danger': hasError('first_name') }" :disabled="loading" ref="first-name" class="input custom-input-size is-medium m-top-10" placeholder="First name" autocomplete="off">
                <p v-show="hasError('first_name')" class="help is-danger">{{ getError('first_name') }}</p>
                <!-- END First Name -->

                <!-- BEGIN Last Name -->
                <input id="last_name" type="text" v-model="lastName" @keyup.enter="register" :class="{ 'is-danger': hasError('last_name') }" :disabled="loading" ref="last-name" class="input custom-input-size is-medium m-top-30" placeholder="Last name" autocomplete="off">
                <p v-show="hasError('last_name')" class="help is-danger">{{ getError('last_name') }}</p>
                <!-- END Last Name -->

                <!-- BEGIN Email -->
                <input id="email" type="text" v-model="email" @keyup.enter="register" :class="{ 'is-danger': hasError('email') }" :disabled="loading" ref="email" class="input custom-input-size is-medium m-top-30" placeholder="Email" autocomplete="off">
                <p v-show="hasError('email')" class="help is-danger">{{ getError('email') }}</p>
                <!-- END Email -->

                <!-- BEGIN Password -->
                <input id="password" type="password" v-model="password" @keyup.enter="register" :class="{ 'is-danger': hasError('password') }" :disabled="loading" class="input custom-input-size is-medium m-top-30" placeholder="Password" autocomplete="off">
                <p v-show="hasError('password')" class="help is-danger">{{ getError('password') }}</p>
                <!--END Password -->

                <!-- BEGIN Password -->
                <input id="password_confirmation" type="password" v-model="passwordConfirmation" @keyup.enter="register" :class="{ 'is-danger': hasError('password_confirmation') }" :disabled="loading" class="input custom-input-size is-medium m-top-30" placeholder="Password confirmation" autocomplete="off">
                <p v-show="hasError('password_confirmation')" class="help is-danger">{{ getError('password_confirmation') }}</p>
                <!--END Password -->

                <div id="login-button" @click="register" :class="{ 'is-loading': loadingRegister }" :disabled="loadingGithub" class="button custom-button-size is-fullwidth is-info m-top-30">Create account</div>

                <div class="login-button-divider">
                    <span>or</span>
                </div>

                <div id="github-button" @click="registerWithGithub" :class="{ 'is-loading': loadingGithub }" :disabled="loadingRegister" class="button custom-button-size is-fullwidth is-github m-top-15">
                    <font-awesome-icon :icon="['fab', 'github']"/>
                </div>

                <!-- BEGIN Actions -->
                <div class="columns">
                    <div class="column has-text-centered">
                        <div class="actions">
                            <!-- <p class="action">Forgot your password? <a href="#">Reset Password</a></p> -->
                            <p class="action" style="margin-top: 10px; font-size: 12px;">By signing up, you agree to the <router-link to="/terms">Terms of Service</router-link> and <router-link to="/privacy">Privacy Policy</router-link>.</p>
                            <p class="action" style="margin-top: 10px;">Do you already have an account? <router-link to="/login">Log In</router-link></p>
                        </div>
                    </div>
                </div>
                <!-- END Actions -->
            </div>
        </div>
    </div>
</template>

<script>
import Api from '@/api';
import FormErrorsMixin from '@/mixins/FormErrors';

export default {
    name: 'register',

    components: {
        //
    },

    mixins: [FormErrorsMixin],

    metaInfo: {
        title: 'Register - Weap.io',
        meta: [
            { name: 'description', content: 'Create a new account to have more frequent DigitalOcean backups using Weap.io' },
        ],
    },

    mounted() {
        if (this.$route.query.error) {
            this.error = this.$route.query.error;
        }
        this.checkToken();
    },

    data() {
        return {
            loadingRegister: false,
            loadingGithub: false,
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            passwordConfirmation: '',
            allowedInputs: ['first_name', 'last_name', 'email', 'password'],
            error: '',
            tokenChecked: false,
            tokenValid: false,
        }
    },

    methods: {
        register() {
            if (this.loading) {
                return;
            }

            this.loadingRegister = true;
            this.resetErrors();

            Api().post('users', this.registrationData)
                .then(response => {
                    localStorage.authenticationToken = response.data.token;
                    localStorage.userId = response.data.user_id;
                    localStorage.email = this.email.toLowerCase();
                    this.$router.push({ name: 'dashboard' });
                })
                .catch(error => {
                    if (!this.storeErrors(error.response.data.errors)) {
                        this.error = 'Something wrong happened. Refresh the page and try again.';
                    }
                })
                .finally(() => {
                    this.loadingRegister = false;
                })
            ;
        },

        registerWithGithub() {
            if (this.loading) {
                return;
            }

            this.loadingGithub = true;
            this.error = '';
            this.resetErrors();

            Api().get('token/github?action=register')
                .then(response => {
                    window.location.replace(response.data.github_redirect);
                })
                .catch(error => {
                    this.error = 'Something wrong happened. Refresh the page and try again.';
                    this.loadingGithub = false;
                });
        },

        checkToken() {
            if (localStorage && localStorage.getItem('authenticationToken')) {
                var token = localStorage.getItem('authenticationToken');
                Api().post('token', { token: token })
                    .then((response) => {
                        if (response.data.valid) {
                            // this.tokenValid = true;
                            this.$router.push({ name: 'dashboard' });
                            return;
                        } else {
                            this.tokenValid = false;
                        }
                    })
                    .finally(() => {
                        this.tokenChecked = true;
                    });
            } else {
                this.tokenChecked = true;
                this.tokenValid = false;
            }
        },
    },

    computed: {
        loading() {
            return this.loadingRegister || this.loadingGithub;
        },

        registrationData() {
            return {
                first_name: this.firstName,
                last_name: this.lastName,
                email: this.email,
                password: this.password,
                password_confirmation: this.passwordConfirmation,
            }
        },
    },
}
</script>
